(function () {
  var rememberMode = document.documentElement.dataset.localeRememberMode;
  var overrideDurationDays = parseInt(document.documentElement.dataset.localeOverrideDuration, 10) || 365;
  var persistAllowed = false; // default: fail closed to session until consent is verified

  function resolvePersistConsent() {
    if (typeof window.Shopify === 'undefined' || typeof window.Shopify.loadFeatures !== 'function') {
      persistAllowed = true; // no Customer Privacy API on this store -- nothing to gate against
      return;
    }
    window.Shopify.loadFeatures(
      [{ name: 'consent-tracking-api', version: '0.1' }],
      function (error) {
        if (error) return;
        if (
          !window.Shopify.customerPrivacy ||
          typeof window.Shopify.customerPrivacy.currentVisitorConsent !== 'function'
        ) {
          return;
        }
        var consent = window.Shopify.customerPrivacy.currentVisitorConsent();
        persistAllowed = consent.preferences === 'yes';
      }
    );
  }

  /** @param {string} value */
  function setPersistentCookie(value) {
    var expires = new Date();
    expires.setTime(expires.getTime() + overrideDurationDays * 24 * 60 * 60 * 1000);
    document.cookie =
      'locale_manual_override=' + encodeURIComponent(value) + '; expires=' + expires.toUTCString() + '; path=/; SameSite=Lax; Secure';
  }

  /** @param {string} value */
  function setSessionMarker(value) {
    try {
      window.sessionStorage.setItem('locale_manual_override', value);
    } catch (e) {
      // storage unavailable -- nothing more we can do
    }
  }

  /** @param {string} value */
  function onLocalizationFormSubmit(value) {
    if (rememberMode === 'off') return;
    if (rememberMode === 'persistent' && persistAllowed) {
      setPersistentCookie(value);
      return;
    }
    setSessionMarker(value);
  }

  function maybeRecordOverride(form) {
    if (!form || form.tagName !== 'FORM' || !form.action || form.action.indexOf('/localization') === -1) {
      return;
    }
    var localeField = form.querySelector('input[name="locale_code"]') || form.querySelector('[name="language_code"]');
    if (!localeField || !localeField.value) return;

    // Country-only submits still carry the unchanged language field, so only record
    // an override when the value actually differs from the language the page loaded with.
    var activeLanguage = (document.documentElement.lang || '').toLowerCase();
    if (localeField.value.toLowerCase() === activeLanguage) return;

    onLocalizationFormSubmit(localeField.value);
  }

  document.addEventListener(
    'submit',
    function (event) {
      maybeRecordOverride(event.target);
    },
    true
  );

  // form.submit() doesn't fire a 'submit' event, unlike requestSubmit() -- patch it too.
  var nativeFormSubmit = HTMLFormElement.prototype.submit;
  HTMLFormElement.prototype.submit = function () {
    try {
      maybeRecordOverride(this);
    } catch (e) {
      // never block the real submission
    }
    return nativeFormSubmit.apply(this, arguments);
  };

  if (rememberMode === 'persistent') {
    resolvePersistConsent();
  }
})();
